let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("55GPM")).then(() => parcelRequire('5C4qU'));